export const convertUrlToFile = async ({
  url,
  filename = 'dummy-file',
}: {
  url: string;
  filename?: string;
}): Promise<File> => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();

    const extension = `.${blob.type.split('/')[1]}`;

    if (!filename.endsWith(extension)) {
      filename += extension;
    }

    const file = new File([blob], filename, { type: blob.type });

    return file;
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    throw new Error(`Error fetching and converting the url: ${errorMessage}`);
  }
};
